import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const laboratoryDepartmentsApi = {
    getLaboratoryDepartments: (): Observable<Dtos.GetLaboratoryDepartmentsResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryDepartments = new Dtos.GetLaboratoryDepartments();

        //Send request.
        const response: Promise<Dtos.GetLaboratoryDepartmentsResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getLaboratoryDepartmentById: (id: number): Observable<Dtos.GetLaboratoryDepartmentByIdResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryDepartmentById = new Dtos.GetLaboratoryDepartmentById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetLaboratoryDepartmentByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getLaboratoryDepartmentsByLaboratoryId: (laboratoryId: number): Observable<Dtos.GetLaboratoryDepartmentsByLaboratoryIdResponse> => {
        //Create the request.
        let request: Dtos.GetLaboratoryDepartmentsByLaboratoryId = new Dtos.GetLaboratoryDepartmentsByLaboratoryId();

        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.GetLaboratoryDepartmentsByLaboratoryIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setLaboratoryDepartment: (laboratoryDepartment: Dtos.LaboratoryDepartment): Observable<Dtos.SetLaboratoryDepartmentResponse> => {

        let request: Dtos.SetLaboratoryDepartment = new Dtos.SetLaboratoryDepartment();

        request.laboratoryDepartment = laboratoryDepartment;

        // send request
        const response: Promise<Dtos.SetLaboratoryDepartmentResponse> = client.post(request);

        return Observable.from(response);

    },
    createLaboratoryDepartment: (laboratoryId: number): Observable<Dtos.CreateLaboratoryDepartmentResponse> => {
        //Create the request.
        let request: Dtos.CreateLaboratoryDepartment = new Dtos.CreateLaboratoryDepartment();

        request.laboratoryId = laboratoryId;

        //Send request.
        const response: Promise<Dtos.CreateLaboratoryDepartmentResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    deleteLaboratoryDepartment: (laboratoryDepartmentId: number): Observable<Dtos.DeleteLaboratoryDepartmentResponse> => {
        //Create the request.
        let request: Dtos.DeleteLaboratoryDepartment = new Dtos.DeleteLaboratoryDepartment();

        request.id = laboratoryDepartmentId;

        //Send request.
        const response: Promise<Dtos.DeleteLaboratoryDepartmentResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateLaboratoryDepartment: (laboratoryDepartment: Dtos.LaboratoryDepartment): Observable<Dtos.ValidateLaboratoryDepartmentResponse> => {

        let request: Dtos.ValidateLaboratoryDepartment = new Dtos.ValidateLaboratoryDepartment();

        request.laboratoryDepartment = laboratoryDepartment;

        // send request
        const response: Promise<Dtos.ValidateLaboratoryDepartmentResponse> = client.post(request);

        return Observable.from(response);

    }
}